import { Component, Input } from '@angular/core';

import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
//import { OrderService } from 'src/app/views/order/order.service';
import { DataService } from '../data.service';

@Component({
  selector: '[pink-toast-component]',
  styles: [
    `
      :host {
        position: relative;
        overflow: hidden;
        pointer-events: all;
        cursor: pointer;
        margin: 0 16px 6px;
        box-shadow: 0 0 12px #999;
      }
    `,
  ],
  styleUrls: ['./app-notification.component.scss'],
  templateUrl: './app-notification.component.html',
  preserveWhitespaces: false,
})
export class CustomToast extends Toast {
  // used for demo purposes
  undoString = 'undo';
  @Input() data: any;
  // constructor is only necessary when not using AoT
  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    //private order: OrderService,
    private pass: DataService
  ) {
    super(toastrService, toastPackage);
  }

  public close(event: Event) {
    event.stopPropagation();
    this.toastrService.clear(this.data.toastId);
  }

  public action() {
    if (this.data.action) {
      // if (this.data.action.idNotification) {
      //   this.order
      //     .updateReadStatusNotification(this.data.action.idNotification)
      //     .subscribe((res) => {});
      //   this.pass.changeTypeLoad('1');
      // }
      // if (this.data.action.idReminder) {
      //   this.order
      //     .updateReadStatusReminder(this.data.action.idReminder)
      //     .subscribe((res) => {});
      //   this.pass.changeTypeLoad('2');
      // }
      // const duplicate = this.data.type === 'dup' ? '&duplicate=true' : '';
      // window.open(`/order?id=${this.data.action.idOrder}${duplicate}`, 'blank');
    }
  }
}
